<template>
  <div class="note-wrapper">
    <div
      ref="note"
      class="note keep-whitespaces"
      :class="{ expanded: isExpanded }"
    >
      {{ note }}
    </div>
    <div
      v-if="showToggle"
      class="toggle-button text-sm"
      @click="toggleNote"
    >
      {{ isExpanded ? 'Show less' : 'Show all' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    note: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isExpanded: false,
      showToggle: false
    };
  },
  mounted() {
    this.checkOverflow();
  },
  methods: {
    toggleNote() {
      this.isExpanded = !this.isExpanded;
    },
    checkOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.note;
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const clampHeight = lineHeight * 3;
        if (el.scrollHeight > clampHeight + 1) {
          this.showToggle = true;
        }
      });
    }
  },
  watch: {
    note() {
      this.isExpanded = false;
      this.showToggle = false;
      this.checkOverflow();
    }
  }
};
</script>

<style scoped>
.note-wrapper {
  font-size: 1rem;
  line-height: 1.5em;
  max-width: 600px;
  margin: 0 auto;
}

.note {
  white-space: pre-line;
  overflow: hidden;
  max-height: 4.5em; /* 3 lines × 1.5em */
  transition: max-height 0.3s ease;
}

.note.expanded {
  max-height: none;
}

.toggle-button {
  color: var(--brand-color);
  cursor: pointer;
  margin-top: 4px;
}
</style>
